export default {
  Subs: {
    For: "Subscription for",
    PTM: "The platform for doctors 'Third Opinion'",
    BySub: "By subscription",
    Free: "Free",
    CostDesc: "at <period> per user",
    month: "month",
    day: "day",
    year: "year",
    Connect: "Connect",
    Connectv2: "Connect subscription",
    CorpPlan: {
      desc: "Individual",
      feature_1: "Individual programs",
      feature_2:
        "Processing a selected number of studies per month using any AI",
      cost: "On request",
      request: "Submit a request",
      requested: "Your request has been successfully submitted!",
      requested2:
        "We will contact you shortly to discuss all the details and offer a suitable solution. \n If you have any questions, <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>write to us!</a>",
    },
    yourSub: "Already with you",
    PlansDesc: "Detailed description of tariffs",
    Offer: "Offer",
    EnterPromo: "Enter promo code",
    Errors: {
      NotPurchase: "Failed to connect the subscription, please try again later",
    },
    DiffSubs: "Differences in tariffs",
    Plan: "Tariff",
    Unavailable: "You need to unsubscribe first",
    extSub: "Select Extended",
    lets: {
      modalTitle: {
        base: "Enter your",
        and: " and ",
        phone: " phone number",
        email: " email",
      },
      text: "To complete the subscription, you need to enter your <PHONE><EMAIL>. This will allow us to send you notifications about the subscription status, transaction confirmations, and other important messages.",
      formInvalid: "The form is filled out incorrectly",
    },
    cancelSub: "Cancel",
    unsub: {
      title: "You will no longer have access to:",
      modalTitle: "Are you sure you want to cancel your subscription?",
      modalTitle2: "Select the reason for cancellation",
      cancel:
        "The <NAME> subscription has been renewed. The next charge will be on <DATE>.",
      yes: "Cancel Subscription",
      no: "Keep Subscription",
      thx: {
        title: "Thank you for staying with us!",
        continue: "Continue",
      },
      reasons: {
        0: "The price is not suitable",
        1: "I don't use the service",
        2: "Inconvenient interface",
        3: "Other",
      },
      complete: {
        title: "You have canceled your subscription",
        text1: "Your subscription will remain active until ",
        text2:
          ", you can continue using the subscription until that time. \nWe will be happy to see you again!",
        recover: "Reactivate Subscription",
      },
    },
    backToSite: "Back to Site",
    afterPay: {
      title: "Your subscription has been successfully activated!",
      text: "You now have access to the extended features of the service!",
      buttonText: "Get Started",
    },
  },
};
